export const receiptCollectionPurposeOptions = [
    { label: 'Thu tiền dịch vụ/sản phẩm', value: 'PAYMENT' },
    { label: 'Nhận cọc', value: 'DEPOSIT' },
    { label: 'Phiếu cũ chưa phân loại', value: 'LEGACY_UNCLASSIFIED' },
];

export const depositScopeOptions = [
    { label: 'Cọc chung', value: 'GENERAL' },
    { label: 'Cọc theo dịch vụ', value: 'SERVICE' },
];

export const depositStatusLabels = {
    ACTIVE: 'Còn khả dụng',
    PARTIALLY_USED: 'Còn một phần',
    USED: 'Đã sử dụng hết',
    REFUNDED: 'Đã hoàn hết',
    CANCELLED: 'Đã hủy',
};

export function getDepositStatusLabel(status) {
    return depositStatusLabels[status] || 'Chưa xác định';
}

export function getReceiptCollectionPurposeLabel(collectionPurpose) {
    const matched = receiptCollectionPurposeOptions.find(item => item.value === collectionPurpose);
    return matched?.label || 'Chưa xác định';
}

export const depositTransactionLabels = {
    DEPOSIT_RECEIVED: 'Nhận cọc',
    DEPOSIT_APPLIED_TO_SERVICE: 'Sử dụng cọc',
    DEPOSIT_TARGET_CHANGED: 'Đổi dịch vụ dự kiến',
    DEPOSIT_ADJUSTMENT_IN: 'Điều chỉnh tăng',
    DEPOSIT_ADJUSTMENT_OUT: 'Điều chỉnh giảm',
    DEPOSIT_RECEIPT_UPDATED_IN: 'Tăng tiền thực thu',
    DEPOSIT_RECEIPT_UPDATED_OUT: 'Giảm tiền thực thu',
    DEPOSIT_RECEIPT_UPDATED: 'Cập nhật phiếu cọc',
    DEPOSIT_RECEIPT_CANCELLED: 'Hủy phiếu cọc',
    DEPOSIT_REFUNDED: 'Hoàn cọc',
    DEPOSIT_REVERSAL: 'Đảo giao dịch cọc',
    DEPOSIT_TRANSFERRED_OUT: 'Chuyển cọc sang khách khác',
    DEPOSIT_TRANSFERRED_IN: 'Nhận cọc từ khách khác',
};

export function getDepositTransactionLabel(transactionType) {
    return depositTransactionLabels[transactionType] || 'Giao dịch cọc';
}

/** Chuẩn hóa bốn số liệu dùng chung trên các form hoàn tiền. */
export function getRefundDisplayAmounts(data) {
    return {
        originalAmount: Math.max(0, Number(data?.refund_receipt?.amount_paid || 0)),
        refundedAmount: Math.max(0, Number(data?.refunded_amount || 0)),
        refundableAmount: Math.max(0, Number(data?.refundable_amount || 0)),
        depositBalance: Math.max(0, Number(data?.refundable_deposit_amount || 0)),
    };
}

/** Rút gọn chuỗi trình bày do projection cũ trả về, không thay đổi dữ liệu nguồn. */
export function formatDepositDisplayText(value, fallback = '') {
    const displayText = value == null ? '' : String(value).trim();
    if (!displayText) return fallback;

    const prefixes = [
        ['Tiền cọc hiện liên kết dịch vụ: ', 'Cọc cho dịch vụ: '],
        ['Nhận tiền cọc cho dịch vụ: ', 'Nhận cọc cho: '],
        ['Nhận cọc cho dịch vụ: ', 'Nhận cọc cho: '],
    ];
    const matched = prefixes.find(([prefix]) => displayText.startsWith(prefix));
    if (matched) return `${matched[1]}${displayText.slice(matched[0].length)}`;

    const exactLabels = {
        'Tiền cọc hiện liên kết dịch vụ đã chọn': 'Cọc cho dịch vụ đã chọn',
        'Tiền cọc hiện chưa liên kết dịch vụ': 'Cọc chưa gắn dịch vụ',
        'Nhận cọc cho dịch vụ đã liên kết': 'Nhận cọc cho dịch vụ',
        'Nhận tiền cọc chung': 'Nhận cọc chung',
    };
    return exactLabels[displayText] || displayText;
}

/**
 * Nội dung hiện hành của phiếu thu. Tiền cọc dùng projection từ backend;
 * phiếu thường dùng danh sách receipt_items đang hoạt động.
 */
export function getReceiptCurrentContent(receipt) {
    if (!receipt) return '';
    if (receipt.collection_purpose === 'DEPOSIT') {
        return formatDepositDisplayText(receipt?.deposit_info?.content, 'Chưa có thông tin cọc');
    }

    return (receipt.items || [])
        .map(item => item?.name)
        .filter(Boolean)
        .join(', ');
}

/** Hiển thị kết quả thu tiền từ đúng purpose/result do backend đã xác định. */
export function renderReceiptCollectionResult(collectionPurpose, settlementResult) {
    if (collectionPurpose === 'DEPOSIT') return 'Nhận cọc';
    if (collectionPurpose === 'CUSTOMER_TRANSFER') return 'Chuyển tiền khách hàng';

    const resultLabels = {
        FULL: 'Thu đủ tiền dịch vụ',
        PARTIAL: 'Thu một phần tiền dịch vụ',
        OVERPAID: 'Thu tiền dịch vụ, còn dư',
        BALANCE_ONLY: 'Ghi nhận số dư khách hàng',
        DEPOSIT: 'Khoản thu chưa phân bổ',
    };

    if (resultLabels[settlementResult]) return resultLabels[settlementResult];
    if (collectionPurpose === 'PAYMENT') return 'Thu tiền dịch vụ';
    if (collectionPurpose === 'LEGACY_UNCLASSIFIED') return 'Phiếu thu cũ chưa phân loại';
    return 'Chưa xác định';
}
